// extracted by mini-css-extract-plugin
export default {"main-container":"PlantioColheita_main-container__ZwmY2","drawerTrans":"PlantioColheita_drawerTrans__tYtDo"};